import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const METADATA_COVERAGE_QUERY_KEY = 'metadataCoverage';

export function useGetMetadataCoverage() {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [METADATA_COVERAGE_QUERY_KEY, { tenantId }],
    queryFn: async () => api.assets.getMetadataCoverage(tenantId),
    select: data => data.data,
    enabled: !!tenantId,
    placeholderData: previousData => previousData,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  });
}
